
import { Component, ChangeDetectionStrategy, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NotificationComponent } from './components/notification/notification.component';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    NotificationComponent
  ],
})
export class AppComponent implements OnDestroy, OnInit {
  private router: Router = inject(Router);
  private document: Document = inject(DOCUMENT);
  private routerSubscription: Subscription;

  constructor() {
    this.routerSubscription = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(event => {
      if (event.urlAfterRedirects.startsWith('/portal')) {
        this.document.body.classList.add('customer-portal-active');
      } else {
        this.document.body.classList.remove('customer-portal-active');
      }
    });
  }
  
  ngOnInit(): void {
    // Tailwind JIT workaround removed as we are now using build-time compilation.
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }
}
